import React, { useRef, useState } from 'react';
import './FormContactsNew.scss';
import './FormContactsNew-media.scss';
import '../../services/CssTransitionModal.scss';
import Input from '../Input/Input';
import InputPhone from '../Input/InputPhone';
import Button from '../Button/Button';
import { ServiceData } from '../../redux/services/ServiceRedux';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import ErrorText from '../ErrorText/ErrorText';
import { AdaptiveValue, MediaContent, ValidationFormItems } from '../../services/GlobalFunctions';
import { LinkTg } from '../../services/content/Constants';
import { Props } from './interfaces';
import { SvgTg } from './constants';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { CSSTransition } from 'react-transition-group';
import SuccessContent from '../SuccessContent/SuccessContent';
import {content} from "../../services/content";
import AgreementCheckboxes from "../AgreementCheckboxes/AgreementCheckboxes";
import ErrorTextBlocked from "../ErrorTextBlocked/ErrorTextBlocked";

declare const ym: any;
declare const _tmr: any;

const FormContactsNew = ({
  title = 'Остались вопросы?',
  subTitle = 'Dalli всегда рядом',
  buttonText = 'Отправить',
  image,
  imageText,
  widthRight,
  telegram = false,
  blockedSend,
  blockedSendLoaded,
  widthWindow,
  eventMetrika,
  recaptchaV2ref,
  contactForms,
}: Props) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('+7');
  const [email, setEmail] = useState('');
  const [successShow, setSuccessShow] = useState(false);
  const [errorPhone, setErrorPhone] = useState<string | null>(null);
  const [errorEmail, setErrorEmail] = useState<string | null>(null);
  const [serverText, setServerText] = useState<string | null>(null);
  const showEmail = !!contactForms?.show_email;
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [allowMarketing, setAllowMarketing] = useState(true);
  const [privacyErrorCount, setPrivacyErrorCount] = useState(0);

  const success = () => {
    setName('');
    setPhone('+7');
    setEmail('');
    setSuccessShow(true);
    if (typeof ym !== 'undefined') {
      ym(26501373, 'reachGoal', 'feedback_success');
    }
    if (typeof _tmr !== 'undefined') {
      _tmr.push({ type: 'reachGoal', id: 3737442, goal: 'vkamolead'});
    }
    setDisableBtn(false);
    setPrivacyPolicyAccepted(false);
    setAllowMarketing(true);
    setPrivacyErrorCount(0);
    setErrorPhone(null);
    setErrorEmail(null);
    setServerText(null);
  };

  const OnTimeOut = () => {
    setTimeout(() => setSuccessShow(false), 3000);
  };

  const { executeRecaptcha } = useGoogleReCaptcha(); // v3

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();

    if (!privacyPolicyAccepted) {
      setPrivacyErrorCount(c => c + 1);
      return;
    }

    setDisableBtn(true);
    setErrorPhone(null);
    setErrorEmail(null);
    setServerText(null);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    // v3
    let token = '';
    if (!executeRecaptcha) {
      console.debug('recaptcha not set, ignoring');
    } else {
      token = await executeRecaptcha(); // v3
    }

    if (!ValidationFormItems({ phone, setErrorPhone, email, setErrorEmail, requireEmail: showEmail })) {
      setDisableBtn(false);
      return;
    }
    ServiceData.submitForm({
      data: {
        name,
        phone,
        allowMarketing,
        ...(showEmail ? { email } : {}),
      },
      success,
      setServerText,
      token,
      blockedSendLoaded,
      eventMetrika,
      contactFormId: contactForms.new_contact_form_id // Ensure this ID is correct
    });
  };

  const widthR = widthRight ? AdaptiveValue({ widthWindow, value: widthRight }) : 'auto';

  const nodeRefSuccess = useRef(null);
  const nodeRef = useRef(null);

  return (
    <>
      <div className="form-contacts-new">
        <CSSTransition
          in={successShow}
          nodeRef={nodeRefSuccess}
          timeout={{ appear: 200, enter: 0, exit: 200 }}
          classNames="css-transition-modal"
          unmountOnExit
          onEnter={OnTimeOut}
        >
          <SuccessContent refCss={nodeRefSuccess} />
        </CSSTransition>

        <CSSTransition
          in={!successShow}
          nodeRef={nodeRef}
          timeout={{ appear: 200, enter: 0, exit: 0 }}
          classNames="css-transition-content"
          unmountOnExit
        >
          <div
            ref={nodeRef}
            className="form-contacts-new__block"
            style={widthRight ? { gridTemplateColumns: `auto ${widthR}` } : {}}
          >
            <div className="form-contacts-new__block-header">
              {!image ? (
                <>
                  <div className="form-contacts-new__block-title">
                    <h2 className="form-contacts-new__title">{title}</h2>
                    <p className="body1">{subTitle}</p>
                  </div>

                  <div>
                    {telegram ? (
                      <a href={LinkTg} target="_blank" className="form-contacts-new__soc" rel="nofollow">
                        {SvgTg}
                      </a>
                    ) : null}
                  </div>
                </>
              ) : (
                MediaContent(
                  <>
                    <img src={image} className="form-contacts-new__image" alt="form" />
                    {imageText ? (
                      <div
                        className="form-contacts-new__image-text"
                        dangerouslySetInnerHTML={{ __html: imageText }}
                      ></div>
                    ) : null}
                  </>,
                  null
                )
              )}
            </div>

            <form onSubmit={handleReCaptchaVerify}>
              {image ? (
                <div className="form-contacts-new__block-title">
                  <h2 className="form-contacts-new__title">{title}</h2>
                  <p className="body1">{subTitle}</p>
                </div>
              ) : null}

              <Input
                label={content.formContacts.inputName}
                name="name"
                value={name}
                onChange={(e: any) => setName(e.target.value)}
                error={null}
                marginTop={0}
              />

              <InputPhone
                label={content.formContacts.inputPhone}
                name="phone"
                value={phone}
                onChange={(e: any) => {
                  setPhone(e.target.value);
                  if (errorPhone) setErrorPhone(null);
                  if (serverText) setServerText(null);
                }}
                error={errorPhone}
              />
              {showEmail && (
                <Input
                  type="email"
                  label={content.formContacts.inputEmail}
                  name="your-email"
                  value={email}
                  onChange={(e: any) => {
                    setEmail(e.target.value);
                    if (errorEmail) setErrorEmail(null);
                    if (serverText) setServerText(null);
                  }}
                  error={errorEmail}
                />
              )}

              {showBlockedError && blockedSend.state && (
                <div className="form-contacts-new__error-blocked">
                  <ErrorTextBlocked counter={blockedSend.counter} />
                </div>
              )}

              <AgreementCheckboxes
                privacyChecked={privacyPolicyAccepted}
                onPrivacyChange={(checked) => {
                  setPrivacyPolicyAccepted(checked);
                  if (checked) setPrivacyErrorCount(0);
                }}
                marketingChecked={allowMarketing}
                onMarketingChange={setAllowMarketing}
                errorTrigger={privacyErrorCount}
              />

              <div className="form-contacts-new__button">
                {serverText && !errorPhone ? ErrorText(serverText, true) : null}
                <Button
                  text={buttonText}
                  widthAll
                  disabled={disableBtn}
                  showBlockedError={showBlockedError}
                />
              </div>
            </form>
          </div>
        </CSSTransition>
      </div>
      <div className="form-contacts-new__bg"></div>
    </>
  );
};

// Custom mergeProps to let ownProps override stateProps (fixes contactForms being overwritten by Redux defaults)
const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default WithStore()(connect(MapStateToProps, MapDispatchToProps, mergeProps)(FormContactsNew));
